import { render, staticRenderFns } from "./ActividadDespacio.vue?vue&type=template&id=7cf268ba&"
import script from "./ActividadDespacio.vue?vue&type=script&lang=ts&"
export * from "./ActividadDespacio.vue?vue&type=script&lang=ts&"
import style0 from "./ActividadDespacio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports